export const cropLink = (link: string) => link.split('cyberform.systems').pop() || '';

export default cropLink;
